class CollectionHiddenGate extends HTMLElement {
  constructor() {
    super()

    this.dialog = null
    this.mode = ''
    this.collectionId = ''
    this.password = ''
  }

  connectedCallback() {
    this.dialog = this.closest('dialog')

    if (!this.dialog) return

    this.mode = this.dataset.mode
    this.collectionId = this.dataset.collectionId
    this.password = this.dataset.password || ''

    if (this.dialog.parentNode !== document.body) {
      document.body.appendChild(this.dialog)
    }

    this.checkAccess()

    this.setupListeners()
    this.setupForm()
  }

  setupListeners() {
    this.dialog.addEventListener('cancel', (event) => {
      event.preventDefault()
    })

    const togglePasswordInput = this.querySelector('[data-collection-hidden-gate-el="toggle-password-input"]')
    togglePasswordInput?.addEventListener('change', this.togglePasswordVisibility.bind(this))
  }

  checkAccess() {
    if (!this.password) {
      this.hideGate()
      return
    }

    const stored = this.getAccess()

    if (stored && stored === this.password) {
      this.hideGate()
    } else {
      this.showGate()
    }
  }

  showGate() {
    if (!this.dialog.open) {
      this.dialog.showModal()
    }

    document.body.setAttribute('data-collection-gate', 'true')
  }

  hideGate() {
    if (this.dialog.open) {
      this.dialog.close()
    }

    document.body.removeAttribute('data-collection-gate', 'true')
  }

  setupForm() {
    const form = this.querySelector('[data-collection-hidden-gate-el="form"]')
    const input = this.querySelector('[data-collection-hidden-gate-el="input"]')
    const errorEl = this.querySelector('[data-collection-hidden-gate-el="error"]')

    if (!form || !input) return

    form.addEventListener('submit', (e) => {
      e.preventDefault()
      const val = (input.value || '').trim()

      if (val && val === this.password) {
        this.setAccess(this.password)

        if (errorEl) {
          errorEl.style.display = 'none'
        }

        this.hideGate()
      } else {
        if (errorEl) {
          errorEl.style.display = 'block'
        }
      }
    })
  }

  togglePasswordVisibility(event) {
    event.stopImmediatePropagation();

    const input = this.querySelector('[data-collection-hidden-gate-el="input"]')
    input.type = input.type === 'password' ? 'text' : 'password'
  }

  setAccess(value) {
    try {
      localStorage.setItem(this.storageKey, value)
    } catch (e) {
      console.warn('Unable to use localStorage:', e)
    }
  }

  getAccess() {
    try {
      return localStorage.getItem(this.storageKey)
    } catch (e) {
      console.warn('Unable to access localStorage:', e)
      return null
    }
  }

  get storageKey() {
    return `BAO-collection-gate-${this.collectionId}`
  }
}

customElements.define('collection-hidden-gate', CollectionHiddenGate)
